(function (angular) {
    angular.module('bizPartEngage').controller('modules.goals.engagementgoals', indexController);
    angular.module('bizPartEngage').controller('modules.goals.onegoal', oneGoalController);

    indexController.$inject = ["modules.goals.service", "$filter"];
    oneGoalController.$inject = ["modules.goals.service", "$stateParams"];

    function indexController(engagementGoalsService, $filter) {
        var vm = this;    
        vm.RootGoals = [];             

        vm.SelectedPeriod = engagementGoalsService.GetSelectedPeriod();

        vm.GetRootGoals = GetRootGoals;

        vm.lblFunction = lblFunction;

        function lblFunction(val, max, goal) {
            return Math.round(val) + goal.GoalType.Suffix;
        }

        function GetRootGoals() {
            engagementGoalsService.GetGoals(true).then(GetRootGoalsCallback);

            function GetRootGoalsCallback(response) {
                var goals = BizPartCoreHelpers.getResponseValue(response, []);                    
                vm.RootGoals = $filter('filter')(goals, { ParentGoalId: -1 });
            }
        }

        vm.$onInit = function () {                        
            vm.GetRootGoals();
        }
    }

    function oneGoalController(engagementGoalsService, $stateParams) {
        var vm = this;
        //vm.GetOneGoal = GetOneGoal;

        vm.goalId = ~~$stateParams.id;            
        vm.newRoot = $stateParams.id === 'new-root';       

        //function GetOneGoal(id) {
        //    engagementGoalsService.GetGoal(id).then(GetGoalCallback);

        //    function GetGoalCallback(response) {
        //        vm.goal =  BizPartCoreHelpers.getResponseValue(response);                
        //    }
        //}

        vm.$onInit = function () {
            //if (vm.goalId > 0) {
            //    vm.GetOneGoal(vm.goalId);
            //} else {
            //    vm.goal = {
            //        Id: 'new'
            //    };
            //}
        }
    }

})(window.angular);
